import type { Building } from "building-types/building/buildingTypes";
import type { Doc } from "building-types/doc";
import type { BuildingEntityType } from "building-types/entities/buildingEntityTypeTypes";
import type { DocEntityHandle } from "building-types/handles/docEntityHandleTypes";

class NullEntityIntegerSourceImpl {
  id: string = "NullEntityIntegerSource";

  getInteger(_: DocEntityHandle): number {
    return 0;
  }

  getHandle(_: number): DocEntityHandle | undefined {
    return undefined;
  }

  getBuildingEntityInteger(_: BuildingEntityType, __: string, ___?: DocEntityHandle): number {
    return 0;
  }

  gc(_: Doc, __: Building) {}

  setEnableGeneratedEntityAllocation(_: boolean) {}

  getEnableGeneratedEntityAllocation(): boolean {
    return false;
  }

  setSelectableWhitelist(_: Set<string> | undefined) {}
  getSelectableWhitelist(): Set<string> | undefined {
    return undefined;
  }

  allocate(_: DocEntityHandle): number {
    return 0;
  }
}

/**
 * An implementation of EntityIntegerSource that does nothing. It is useful for mocking
 * or systems that don't truly require integers to be allocated. When asked for an integer, this
 * system always returns 0.
 */
export const NullEntityIntegerSource = new NullEntityIntegerSourceImpl();
